import React, { useContext, useEffect, useState, useRef } from "react";
import NavSub from "../components/NavSub";
import "../Styles/WeeklyTimesheet.css";
import { AuthContext } from "../context/AuthContext";
import {
  TextField,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  CircularProgress,
} from "@mui/material";
import {
  clientApiUrl,
  taskApiUrl,
  notificationApiUrl,
  userApiUrl,
} from "../utils/GetUrl";
import ToastComponent from "../components/ToastComponent";
import * as XLSX from "xlsx";
import { UserContext } from "../context/UserContext";
import {
  CaretCircleDoubleLeft,
  CaretCircleDoubleRight,
  CaretDown,
  CaretUp,
  FileArrowUp,
} from "phosphor-react";

const WeeklyReview = () => {
  const { usersList } = useContext(UserContext);
  const [clients, setClients] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [viewForce, setViewForce] = useState([]);
  const { userData } = useContext(AuthContext);
  const [selectedUser, setSelectedUser] = useState(userData?.[0]?.EM_ID);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date(); // Current date
    today.setDate(1); // Set to the first day of the current month
    return today.toISOString().split("T")[0]; // Convert to YYYY-MM-DD format
  });

  const [selectedDate2, setSelectedDate2] = useState(
    new Date().toISOString().split("T")[0] // Current date of the current month
  );
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [weeklyReport, setWeeklyReport] = useState([]);
  const { token, logout } = useContext(AuthContext);

  const [loadingActivities, setLoadingActivities] = useState(false);
  const [loadingViewForce, setLoadingViewForce] = useState(false);
  const [loadingWeeklyReport, setLoadingWeeklyReport] = useState(false);

  useEffect(() => {
    if (selectedDate && selectedDate2) {
      const startDate = new Date(selectedDate); // Start date from selectedDate
      const endDate = new Date(selectedDate2); // End date from selectedDate2

      // Format function to get date in YYYY-MM-DD format
      const formatDate = (date) => date.toISOString().split("T")[0];

      // Set formatted start and end dates
      setStartDate(formatDate(startDate));
      setEndDate(formatDate(endDate));
    }
  }, [selectedDate, selectedDate2]);

  useEffect(() => {
    setSelectedUser(userData?.[0]?.EM_ID);
  }, [userData]);

  const toastRef = useRef();
  const fetchActivityList = async () => {
    if (!token) {
      return;
    }
    setLoadingActivities(true); // Start loading
    try {
      const response = await fetch(`${clientApiUrl}/GetAllActivity`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }

      if (response.ok) {
        const data = await response.json();
        const filteredData = data?.filter((i) => i.AL_Status == "1");
        // Filter out undefined and null values, and activities starting with 9114
        const validActivities = [
          ...new Set(
            filteredData
              ?.map((code) => code.AL_SalseforceCode)
              .filter(
                (activity) =>
                  activity &&
                  typeof activity === "string" &&
                  !activity.startsWith("9114")
              )
          ),
        ];
        setActivityList(validActivities);
      }
    } catch (error) {
    } finally {
      setLoadingActivities(false); // End loading
    }
  };

  const fetchViewForce = async () => {
    if (!token) {
      return;
    }
    try {
      const response = await fetch(
        `${taskApiUrl}/GetDataByDate?StartDate=${startDate}&EndDate=${endDate}&EMId=${selectedUser}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }
      if (response.ok) {
        const data = await response.json();
        setViewForce(data);
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const fetchWeekly = async () => {
    if (!token) {
      return;
    }
    setLoadingWeeklyReport(true);
    try {
      const response = await fetch(
        // `https://fn-hampi-taskmanager.azurewebsites.net/api/GetAllTaskClientWiseReport?DateRange1=${startDate}&DateRange2=${endDate}&AssginedToEmids='C3D788DA-090A-11EF-A8D5-6045BDA599B0'`,
        `${taskApiUrl}/GetAllTaskClientWiseReport?DateRange1=${startDate}&DateRange2=${endDate}&AssginedToEmids='${selectedUser}'`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return;
      }
      const data = await response.json();
      setWeeklyReport(data);
    } catch (e) {
    } finally {
      setLoadingWeeklyReport(false); // End loading
    }
  };

  useEffect(() => {
    if (userData && startDate) {
      fetchViewForce();
      fetchWeekly();
    }
  }, [userData, startDate, selectedUser, endDate, token]);

  useEffect(() => {
    fetchActivityList();
  }, [token]);

  const handleActivityChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedActivities(typeof value === "string" ? value.split(",") : value);
  };
  const handleUserChange = (event) => {
    setSelectedUser(event.target.value);
  };
  const checkIfDownloadable = async () => {
    if (!token) return false;

    try {
      const response = await fetch(`${taskApiUrl}/GetFileDownloadAction`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error"
        );
        await logout();
        return false;
      }

      if (response.ok) {
        const data = await response.json();

        if (data && data.length > 0) {
          const validationDateStr = data[0].ValidationDate;
          const todayStr = new Date().toISOString().split("T")[0];

          if (todayStr <= validationDateStr) {
            return true;
          } else {
            toastRef.current.showToast(
              "Your download access has expired.",
              "warning"
            );
            return false;
          }
        } else {
          toastRef.current.showToast(
            "Download access not available.",
            "warning"
          );
          return false;
        }
      } else {
        toastRef.current.showToast("Failed to check download access.", "error");
        return false;
      }
    } catch (error) {
      console.error("Error checking download eligibility:", error);
      toastRef.current.showToast("Error checking download access.", "error");
      return false;
    }
  };

  const downloadExcel = async () => {
    try {
      const { header = [], data = [] } =
        generateReportTable(activityList, weeklyReport, viewForce) || {};

      if (!data.length || !header.length) {
        toastRef.current.showToast("No data available to export", "warning");
        return;
      }

      const user = usersList?.find((u) => u?.EM_ID === selectedUser) || {};
      const userName =
        `${user?.EM_FirstName || ""}${user?.EM_LastName || ""}`.trim() ||
        "User";

      const sheetName = `Weekly_${userName.substring(0, 20)}`
        .replace(/[\\/*?:[\]]/g, "")
        .substring(0, 31);

      // Corrected header order: Client, Synergy Pricing, then the rest
      const baseColumns = [
        "Client (ProjectNumber)",
        "Synergy Pricing", // Changed from "Price Agreement" to "Synergy Pricing"
        "Price Agreement", // Moved to column C
      ];

      const visibleColumns = [];

      const firstRowData = data[0] || {};
      const reportingActivities = firstRowData?.ReportingActivities || {};

      if (isHoursExpanded) {
        baseColumns.push(
          "Synergy Fixed Minutes",
          "Fixed Minutes Voucher Processing",
          "STR Activity Avg Time"
        );

        Object.keys(reportingActivities).forEach((activityName) => {
          baseColumns.push(
            activityName.length > 20
              ? `${activityName.substring(0, 17)}...`
              : activityName
          );
        });
      }

      const activityCount = header.length ? Math.floor(header.length / 3) : 0;

      if (isActualTimeExpanded && header.length > 1) {
        header.slice(1, activityCount + 1).forEach((col) => {
          if (col) {
            visibleColumns.push(
              col.length > 20 ? `${col.substring(0, 17)}...` : col
            );
          }
        });
      }

      if (isViewForceTimeExpanded && header.length > activityCount + 1) {
        header
          .slice(activityCount + 1, 2 * activityCount + 1)
          .forEach((col) => {
            if (col) {
              visibleColumns.push(
                col.length > 25 ? `${col.substring(0, 22)}...` : col
              );
            }
          });
      }

      if (isDifferenceExpanded && header.length > 2 * activityCount + 1) {
        header.slice(2 * activityCount + 1).forEach((col) => {
          if (col) {
            visibleColumns.push(
              col.length > 25 ? `${col.substring(0, 22)}...` : col
            );
          }
        });
      }

      // Combine all columns with corrected order
      const allColumns = [...baseColumns, ...visibleColumns];

      const worksheetData = [
        allColumns,
        ...data.map((row) => {
          // Corrected column order in the data rows
          const rowData = [
            `${row?.Client || ""} (${row?.ProjectNumber || ""})`,
            row?.SynergyPriceAgreement || "", // This is now "Synergy Pricing" in column B
            "", // Placeholder for "Price Agreement" in column C
          ];

          if (isHoursExpanded) {
            rowData.push(
              row?.SynergyFixedMinutes || 0,
              row?.FixedMinutesVoucherProcessing || 0,
              row?.STRActivityAverageTime || 0
            );

            if (row?.ReportingActivities) {
              Object.values(row.ReportingActivities).forEach((time) => {
                rowData.push(time || 0);
              });
            }
          }

          if (isActualTimeExpanded) {
            header.slice(1, activityCount + 1).forEach((activity) => {
              rowData.push(row[activity] || 0);
            });
          }

          if (isViewForceTimeExpanded) {
            header
              .slice(activityCount + 1, 2 * activityCount + 1)
              .forEach((activity) => {
                rowData.push(row[activity] || 0);
              });
          }

          if (isDifferenceExpanded) {
            header.slice(2 * activityCount + 1).forEach((activity) => {
              const value = row[activity];
              rowData.push(
                value !== undefined && value !== null
                  ? parseFloat(value).toFixed(2)
                  : 0
              );
            });
          }

          return rowData;
        }),
      ];

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      if (worksheet["!cols"] === undefined) {
        worksheet["!cols"] = [];
      }

      allColumns.forEach((col, index) => {
        const maxContentLength = Math.max(
          col?.length || 0,
          ...worksheetData.slice(1).map((row) => {
            const value = row[index];
            return value ? value.toString().length : 0;
          })
        );

        worksheet["!cols"][index] = {
          wch: Math.min(50, Math.max(10, maxContentLength)),
        };
      });

      if (worksheetData.length > 1) {
        worksheet["!freeze"] = { x: 0, y: 1 };
      }

      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      XLSX.writeFile(
        workbook,
        `WeeklyReport_${userName.substring(0, 50)}.xlsx`
      );
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toastRef.current?.showToast("Failed to export Excel file", "error");
    }
  };
  // Usage example: Add a button to trigger the download

  function generateReportTable(activityList, weeklyReport, viewForce) {
    // Filter out undefined/null activities and activities starting with 9114
    const filteredActivities = (
      selectedActivities.length > 0 ? selectedActivities : activityList
    ).filter(
      (activity) =>
        activity && typeof activity === "string" && !activity.startsWith("9114")
    );

    const uniqueActivities = [...new Set(filteredActivities)];

    const tableHeader = [
      "Client",
      ...uniqueActivities,
      ...uniqueActivities.map((a) => `${a} ViewForce`),
      ...uniqueActivities.map((a) => `${a} Difference`),
    ];

    const clientNames = [
      ...new Set(weeklyReport.map((report) => report.ClientName)),
    ];

    const clientIds = [
      ...new Set(weeklyReport.map((report) => report.ClientId)),
    ];
    const projectIds = [
      ...new Set(weeklyReport.map((report) => report.ProjectNumber)),
    ];

    const tableData = clientNames.map((clientName, index) => {
      const clientId = clientIds[index];
      const projectId = projectIds[index];
      // Find the first report for this client to get additional fields
      const clientReport = weeklyReport.find(
        (report) => report.ClientName === clientName
      );

      // Get reporting activities from standardActivitiesTime
      const reportingActivities = {};
      if (clientReport?.standardActivitiesTime) {
        clientReport.standardActivitiesTime.forEach((activity) => {
          if (activity.ActivityType === "Reporting Activites") {
            reportingActivities[activity.ActivityName] = activity.SATTime;
          }
        });
      }

      const clientRow = {
        clientName: clientName,
        clientId: clientId,
        ProjectNumber: projectId,
        SynergyPriceAgreement: clientReport?.SynergyPriceAgreement || "",
        SynergyFixedMinutes: clientReport?.SynergyFixedMinutes || "0",
        FixedMinutesVoucherProcessing:
          clientReport?.FixedMinutesVoucherProcessing || "0",
        STRActivityAverageTime: clientReport?.STRActivityAverageTime || "0",
        ReportingActivities: reportingActivities,
        activitiesTotalTime: {},
        activitiesViewForceTime: {},
        activitiesDifference: {},
      };

      uniqueActivities.forEach((activity) => {
        clientRow.activitiesTotalTime[activity] = 0;
        clientRow.activitiesViewForceTime[activity] = 0;
        clientRow.activitiesDifference[activity] = 0;
      });

      weeklyReport.forEach((report) => {
        if (report.ClientName === clientName) {
          // Check if the SalesforceCode exists in our filtered activities
          if (
            report.SalesforceCode &&
            clientRow.activitiesTotalTime[report.SalesforceCode] !== undefined
          ) {
            clientRow.activitiesTotalTime[report.SalesforceCode] += parseFloat(
              parseFloat(report.TotalTime).toFixed(2)
            );
          }
        }
      });

      // Helper function to normalize activity names (case-insensitive)
      const normalizeActivityName = (name) => name?.trim().toLowerCase() || "";

      viewForce.forEach((view) => {
        // 1. Strict clientId match
        if (view.clientId == clientId) {
          // 2. Find matching activity (case-insensitive)
          const matchedActivity = uniqueActivities.find(
            (activity) =>
              normalizeActivityName(activity) ===
              normalizeActivityName(view.activity)
          );

          // 3. If activity exists in selected list, sum the time
          if (matchedActivity) {
            const timeMinutes = parseFloat(view.registeredTime);
            if (!isNaN(timeMinutes)) {
              clientRow.activitiesViewForceTime[matchedActivity] =
                (clientRow.activitiesViewForceTime[matchedActivity] || 0) +
                timeMinutes * 60;
            }
          }
        }
      });

      uniqueActivities.forEach((activity) => {
        clientRow.activitiesDifference[activity] =
          clientRow.activitiesTotalTime[activity] -
          clientRow.activitiesViewForceTime[activity];
      });

      return clientRow;
    });

    return {
      header: tableHeader,
      data: tableData.map((clientRow) => {
        const row = {
          Client: clientRow.clientName,
          ProjectNumber: clientRow.ProjectNumber,
          SynergyPriceAgreement: clientRow.SynergyPriceAgreement,
          SynergyFixedMinutes: clientRow.SynergyFixedMinutes,
          FixedMinutesVoucherProcessing:
            clientRow.FixedMinutesVoucherProcessing,
          STRActivityAverageTime: clientRow.STRActivityAverageTime,
          ReportingActivities: clientRow.ReportingActivities,
        };
        uniqueActivities.forEach((activity) => {
          row[activity] = clientRow.activitiesTotalTime[activity];
          row[`${activity} ViewForce`] =
            clientRow.activitiesViewForceTime[activity];
          row[`${activity} Difference`] =
            clientRow.activitiesDifference[activity];
        });
        return row;
      }),
    };
  }

  const { header, data } = generateReportTable(
    activityList,
    weeklyReport,
    viewForce
  );

  const menuItemStyle = {
    height: "30px",
  };

  const getRowStyle = (index) => ({
    backgroundColor: index % 2 === 0 ? "#f0f0f0" : "white",
  });

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isOpen, setIsOpen] = useState(false); // State to track dropdown open/close

  const handleDropdownOpen = () => {
    setIsOpen(true);
  };

  const handleDropdownClose = () => {
    setIsOpen(false);
  };
  const tableContainerRef = useRef(null);
  const handleMouseScroll = () => {
    const tableContainer = tableContainerRef.current;

    let isDown = false;
    let startX;
    let scrollLeft;

    const mouseDownHandler = (e) => {
      isDown = true;
      tableContainer.classList.add("active");
      startX = e.pageX - tableContainer.offsetLeft;
      scrollLeft = tableContainer.scrollLeft;
    };

    const mouseLeaveHandler = () => {
      isDown = false;
      tableContainer.classList.remove("active");
    };

    const mouseUpHandler = () => {
      isDown = false;
      tableContainer.classList.remove("active");
    };

    const mouseMoveHandler = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - tableContainer.offsetLeft;
      const walk = (x - startX) * 2;
      tableContainer.scrollLeft = scrollLeft - walk;
    };
    tableContainer.addEventListener("mousedown", mouseDownHandler);
    tableContainer.addEventListener("mouseleave", mouseLeaveHandler);
    tableContainer.addEventListener("mouseup", mouseUpHandler);
    tableContainer.addEventListener("mousemove", mouseMoveHandler);
    return () => {
      tableContainer.removeEventListener("mousedown", mouseDownHandler);
      tableContainer.removeEventListener("mouseleave", mouseLeaveHandler);
      tableContainer.removeEventListener("mouseup", mouseUpHandler);
      tableContainer.removeEventListener("mousemove", mouseMoveHandler);
    };
  };
  // ////////////////////////////////////////////////////////////////////////////////////////////

  const [isActualTimeExpanded, setIsActualTimeExpanded] = useState(true);
  const [isViewForceTimeExpanded, setIsViewForceTimeExpanded] = useState(false);
  const [isDifferenceExpanded, setIsDifferenceExpanded] = useState(false);

  const [isHoursExpanded, setIsHoursExpanded] = useState(false);
  return (
    <div>
      <NavSub />
      <div className="weekly_time_sheet_head">
        <div>
          <ToastComponent ref={toastRef} timeout={4000} />
          <div className="space-weekly-review">
            <Select
              className="change-font"
              style={{ width: "auto" }}
              value={selectedUser}
              onChange={handleUserChange}
              displayEmpty
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <div className="title-weekly-design-review">
                      SELECT USER{" "}
                      {isOpen ? (
                        <CaretUp
                          size={16}
                          weight="fill"
                          className="icon-select-weekly"
                        />
                      ) : (
                        <CaretDown
                          size={16}
                          weight="fill"
                          className="icon-select-weekly"
                        />
                      )}
                    </div>
                  );
                }
                const selectedUserObject = usersList.find(
                  (u) => u.EM_ID === selected
                );
                return selectedUserObject ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "10px",
                      fontFamily: "Poppins",
                    }}
                  >
                    {selectedUserObject.EM_FirstName +
                      selectedUserObject.EM_LastName}
                    {isOpen ? (
                      <CaretUp
                        size={16}
                        weight="fill"
                        className="icon-select-weekly"
                      />
                    ) : (
                      <CaretDown
                        size={16}
                        weight="fill"
                        className="icon-select-weekly"
                      />
                    )}
                  </div>
                ) : (
                  <div>
                    Select User{" "}
                    {isOpen ? (
                      <CaretUp
                        size={16}
                        weight="fill"
                        className="icon-select-weekly"
                      />
                    ) : (
                      <CaretDown
                        size={16}
                        weight="fill"
                        className="icon-select-weekly"
                      />
                    )}
                  </div>
                );
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                    top: 200,
                  },
                },
              }}
              IconComponent={null} // Ensure no default icon is displayed
              onOpen={handleDropdownOpen} // Update state when dropdown opens
              onClose={handleDropdownClose} // Update state when dropdown closes
            >
              {usersList?.map((u) => (
                <MenuItem key={u.EM_ID} value={u.EM_ID}>
                  <ListItemText
                    primary={u.EM_FirstName + " " + u.EM_LastName}
                  />
                </MenuItem>
              ))}
            </Select>

            <Select
              className="change-font"
              multiple
              value={selectedActivities}
              onChange={handleActivityChange}
              displayEmpty
              onOpen={handleOpen}
              onClose={handleClose}
              IconComponent={() => null}
              renderValue={(selected) => {
                return (
                  <button className="title-weekly-design">
                    SELECT ACTIVITY
                    {open ? (
                      <CaretUp
                        size={16}
                        color="#3d025f"
                        weight="fill"
                        className="icon-select-weekly"
                      />
                    ) : (
                      <CaretDown
                        size={16}
                        color="#3d025f"
                        weight="fill"
                        className="icon-select-weekly"
                      />
                    )}
                  </button>
                );
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              }}
            >
              {activityList?.map((activity) => (
                <MenuItem key={activity} value={activity} sx={menuItemStyle}>
                  <Checkbox
                    checked={selectedActivities.indexOf(activity) > -1}
                  />
                  <ListItemText primary={activity} />
                </MenuItem>
              ))}
            </Select>

            <input
              type="date"
              className="date-design-weekly"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              label="Select Start Date"
            />
            <input
              type="date"
              className="date-design-weekly"
              value={selectedDate2}
              onChange={(e) => setSelectedDate2(e.target.value)}
              label="Select End Date"
            />
          </div>
        </div>

        <div className="Nav-btn-user">
          <FileArrowUp size={25} color="#3d025f" weight="fill" />
          <button className="Nav-Sub-btn" onClick={downloadExcel}>
            DOWNLOAD FILES
          </button>
        </div>
      </div>

      <div
        className="report-table-cont"
        ref={tableContainerRef}
        onMouseEnter={handleMouseScroll}
      >
        {loadingWeeklyReport ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <CircularProgress style={{ color: "purple" }} width={40} />
          </div>
        ) : (
          <table className="report-table">
            <thead>
              <tr className="super-header">
                <th
                  className="client-header"
                  style={{
                    position: "sticky",
                    left: 0,
                    zIndex: 1,
                    background: "rgba(230, 230, 230, 1)",
                  }}
                >
                  CLIENT
                </th>
                <th
                  className="client-header"
                  style={{
                    position: "sticky",
                    left: 304,
                    zIndex: 1,
                    background: "rgba(230, 230, 230, 1)",
                  }}
                >
                  Price Agreement
                </th>

                <th
                  className="hours-header"
                  colSpan={
                    isHoursExpanded
                      ? 3 +
                        Object.keys(data[0]?.ReportingActivities || {}).length
                      : 1
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsHoursExpanded((prev) => !prev)}
                >
                  {isHoursExpanded ? (
                    <CaretCircleDoubleLeft size={32} color="#FFA500" />
                  ) : (
                    <CaretCircleDoubleRight size={32} color="#FFA500" />
                  )}
                  Fixed Time (Mins)
                </th>

                <th
                  className="total-time-header"
                  colSpan={isActualTimeExpanded ? header.length / 3 : 1}
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsActualTimeExpanded((prev) => !prev)}
                >
                  {isActualTimeExpanded ? (
                    <CaretCircleDoubleLeft size={32} color="green" />
                  ) : (
                    <CaretCircleDoubleRight size={32} color="green" />
                  )}
                  ACTUAL TIME
                </th>

                <th
                  className="viewforce-time-header"
                  colSpan={isViewForceTimeExpanded ? header.length / 3 : 1}
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsViewForceTimeExpanded((prev) => !prev)}
                >
                  {isViewForceTimeExpanded ? (
                    <CaretCircleDoubleLeft size={32} color="blue" />
                  ) : (
                    <CaretCircleDoubleRight size={32} color="blue" />
                  )}
                  VIEW FORCE TIME
                </th>

                <th
                  className="difference-header"
                  colSpan={isDifferenceExpanded ? header.length / 3 : 1}
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsDifferenceExpanded((prev) => !prev)}
                >
                  {isDifferenceExpanded ? (
                    <CaretCircleDoubleLeft size={32} color="red" />
                  ) : (
                    <CaretCircleDoubleRight size={32} color="red" />
                  )}
                  DIFFERENCE
                </th>
              </tr>

              <tr className="activity-headers">
                <th className="activity-header table-title-weekly">CLIENT</th>
                <th className="activity-header table-title-weekly">
                  Price Agreement
                </th>

                {isHoursExpanded && (
                  <>
                    <th className="activity-header table-title-weekly">
                      Synergy Fixed Minutes
                    </th>
                    <th className="activity-header table-title-weekly">
                      Fixed Minutes Voucher Processing
                    </th>
                    <th className="activity-header table-title-weekly">
                      STR Activity Average Time
                    </th>
                    {data[0]?.ReportingActivities &&
                      Object.keys(data[0].ReportingActivities).map(
                        (activityName, index) => (
                          <th
                            className="activity-header table-title-weekly"
                            key={`reporting-${index}`}
                          >
                            {activityName}
                          </th>
                        )
                      )}
                  </>
                )}
                {isActualTimeExpanded &&
                  header.slice(1, header.length / 3 + 1).map((head, index) => (
                    <th
                      className="activity-header table-title-weekly"
                      key={`actual-${index}`}
                    >
                      {head}
                    </th>
                  ))}
                {isViewForceTimeExpanded &&
                  header
                    .slice(header.length / 3 + 1, (2 * header.length) / 3 + 1)
                    .map((head, index) => (
                      <th
                        className="activity-header table-title-weekly"
                        key={`viewforce-${index}`}
                      >
                        {head}
                      </th>
                    ))}
                {isDifferenceExpanded &&
                  header
                    .slice((2 * header.length) / 3 + 1)
                    .map((head, index) => (
                      <th
                        className="activity-header table-title-weekly"
                        key={`difference-${index}`}
                      >
                        {head}
                      </th>
                    ))}
              </tr>
            </thead>
            <tbody>
              {data?.map((row, index) => (
                <tr
                  className="client-row"
                  key={index}
                  style={getRowStyle(index)}
                >
                  <td
                    className="client-name content-user"
                    style={{
                      position: "sticky",
                      left: 0,
                      zIndex: 1,
                      backgroundColor:
                        index % 2 === 0
                          ? "rgb(240, 240, 240)"
                          : "rgb(255, 255, 255)",
                    }}
                  >
                    {row.Client} ({row.ProjectNumber})
                  </td>
                  <td
                    className="client-name content-user"
                    style={{
                      position: "sticky",
                      left: 304,
                      zIndex: 1,
                      backgroundColor:
                        index % 2 === 0
                          ? "rgb(240, 240, 240)"
                          : "rgb(255, 255, 255)",
                    }}
                  >
                    {row.SynergyPriceAgreement}
                  </td>

                  {isHoursExpanded && (
                    <>
                      <td className="activity-cell content-user">
                        <div className="activity-cell-value">
                          {row.SynergyFixedMinutes !== undefined &&
                          !isNaN(row.SynergyFixedMinutes)
                            ? parseFloat(row.SynergyFixedMinutes).toFixed(2)
                            : ""}
                        </div>
                      </td>
                      <td className="activity-cell content-user">
                        <div className="activity-cell-value">
                          {row.FixedMinutesVoucherProcessing !== undefined &&
                          !isNaN(row.FixedMinutesVoucherProcessing)
                            ? parseFloat(
                                row.FixedMinutesVoucherProcessing
                              ).toFixed(2)
                            : ""}
                        </div>
                      </td>
                      <td className="activity-cell content-user">
                        <div className="activity-cell-value">
                          {row.STRActivityAverageTime !== undefined &&
                          !isNaN(row.STRActivityAverageTime)
                            ? parseFloat(row.STRActivityAverageTime).toFixed(2)
                            : ""}
                        </div>
                      </td>
                      {row.ReportingActivities &&
                        Object.entries(row.ReportingActivities).map(
                          ([activityName, time], idx) => (
                            <td
                              className="activity-cell content-user"
                              key={`reporting-${index}-${idx}`}
                            >
                              <div className="activity-cell-value">
                                {time !== undefined && !isNaN(time)
                                  ? parseFloat(time).toFixed(2)
                                  : ""}
                              </div>
                            </td>
                          )
                        )}
                    </>
                  )}

                  {isActualTimeExpanded &&
                    header
                      .slice(1, header.length / 3 + 1)
                      .map((activity, activityIndex) => (
                        <td
                          className="activity-cell content-user"
                          key={`actual-${index}-${activityIndex}`}
                        >
                          <div className="activity-cell-value">
                            {row[activity] !== undefined &&
                            !isNaN(row[activity])
                              ? parseFloat(row[activity]).toFixed(2)
                              : ""}
                          </div>
                        </td>
                      ))}

                  {isViewForceTimeExpanded &&
                    header
                      .slice(header.length / 3 + 1, (2 * header.length) / 3 + 1)
                      .map((activity, activityIndex) => (
                        <td
                          className="activity-cell content-user"
                          key={`viewforce-${index}-${activityIndex}`}
                        >
                          <div className="activity-cell-value">
                            {row[activity] !== undefined &&
                            !isNaN(row[activity])
                              ? parseFloat(row[activity]).toFixed(2)
                              : ""}
                          </div>
                        </td>
                      ))}

                  {isDifferenceExpanded &&
                    header
                      .slice((2 * header.length) / 3 + 1)
                      .map((activity, activityIndex) => (
                        <td
                          className="activity-cell content-user"
                          key={`difference-${index}-${activityIndex}`}
                        >
                          <div className="activity-cell-value">
                            {row[activity] !== undefined &&
                            !isNaN(row[activity])
                              ? parseFloat(row[activity]).toFixed(2)
                              : ""}
                          </div>
                        </td>
                      ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default WeeklyReview;
